import { DOCUMENT } from '@angular/common';
import {
  Directive,
  effect,
  HostBinding,
  HostListener,
  inject,
  OnInit,
  Renderer2,
} from '@angular/core';
import { BaseNavService } from '@core/services/base-nav-service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { fromEvent } from 'rxjs';

@UntilDestroy()
@Directive({
  standalone: true,
  selector: '[nodaMenuToggle]',
  exportAs: 'toggleMenuDirective',
})
export class MenuToggleDirective implements OnInit {
  private readonly DESKTOP_BREAKPOINT: number = 1024;
  private renderer: Renderer2 = inject(Renderer2);
  private navService: BaseNavService = inject(BaseNavService);
  private document: Document = inject(DOCUMENT);

  @HostBinding('class.is-active')
  public get isActive(): boolean {
    return this.navService.isMobileMenuOpen();
  }

  constructor() {
    this.initializeEffect();
  }

  @HostListener('click')
  public toggleMenu(): void {
    this.navService.isMobileMenuOpen.update((value: boolean) => !value);
  }

  ngOnInit(): void {
    if (this.document.defaultView) {
      fromEvent(this.document.defaultView, 'resize')
        .pipe(untilDestroyed(this))
        .subscribe(() => this.handleResize());
    }
  }

  private initializeEffect(): void {
    effect((): void => {
      this.updateBodyScroll();
    });
  }

  private updateBodyScroll(): void {
    const htmlElement: HTMLElement = this.document.documentElement;

    if (this.navService.isMobileMenuOpen()) {
      this.renderer.addClass(htmlElement, 'no-body-scroll');
    } else {
      this.renderer.removeClass(htmlElement, 'no-body-scroll');
    }
  }

  private handleResize(): void {
    if (this.document.defaultView.innerWidth >= this.DESKTOP_BREAKPOINT) {
      this.renderer.removeClass(this.document.documentElement, 'no-body-scroll');
      this.navService.isMobileMenuOpen.set(false);
    }
  }
}
